module.exports = __webpack_public_path__ + "assets/img/gas.b8c81ff0.png";